import { render } from "./CIS-Resource-Advisory.vue?vue&type=template&id=13f0a16f"
import script from "./CIS-Resource-Advisory.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Advisory.vue?vue&type=script&lang=js"

import "./CIS-Resource-Advisory.vue?vue&type=style&index=0&id=13f0a16f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__